(() => {
  'use strict';
  const kinds = ['same','adjacent','sextile','square','trine','quincunx','opposition'];
  const glyphs = ['☌','⚺','⚹','□','△','⚻','☍'];
  function profile(a,b) {
    const delta = Math.abs(a-b), distance = Math.min(delta,12-delta);
    return { distance, kind:kinds[distance], glyph:glyphs[distance], degrees:distance*30 };
  }
  function sample(a,b,progress) {
    const type = profile(a,b), angle = progress*Math.PI*2;
    const breath = (1-Math.cos(angle))/2;
    const closeness = type.kind === 'same' || type.kind === 'trine' ? .82 : type.kind === 'sextile' ? .64 : .42;
    return { spread:.23-.17*breath, merge:closeness*breath*breath, orbit:angle,
      lift:Math.sin(angle)*.028, shake:0, pulse:Math.pow(breath,6),
      stage:breath>.85?'confluence':breath>.35?'orbiting':'breathing' };
  }
  window.PairMotion = { profile, sample, duration:22 };
})();
